import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { useGetOrdersQuery } from '../../slices/ordersApiSlice';
import { formatNTD } from '../../utils/pricing';

const OrderListScreen = () => {
  const { data: orders, isLoading, error } = useGetOrdersQuery();
  

  return <>
    <h1>訂單管理</h1>
    {isLoading ? <Loader /> : error ? <Message variant="danger">{error}</Message> : (
      <Table striped hover responsive className="table-sm">
        <thead>
          <tr>
            <th>訂單編號</th>
            <th>會員</th>
            <th>日期</th>
            <th>總金額</th>
            <th>付款</th>
            <th>出貨</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          { orders.map((order) => (
            <tr key={order._id}>
              <td>{order._id}</td>
              <td>{order.user && order.user.name}</td>
              <td>{order.createdAt.substring(0, 10)}</td>
              <td>{formatNTD(order.totalPrice)}</td>
              <td>
                { order.isPaid ? (
                  order.paidAt.substring(0, 10)
                ) : (
                  <FaTimes style={{ color: "red" }} />
                ) }
              </td>
              <td>
                { order.isDelivered ? (
                  order.deliveredAt.substring(0, 10)
                ) : (
                  <FaTimes style={{ color: "red" }} />
                ) }
              </td>
              <td>
                <LinkContainer to={`/order/${order._id}`}>
                  <Button variant="light" className="btn-sm">
                    查看
                  </Button>
                </LinkContainer>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )}
  </>

};

export default OrderListScreen;